import {initPopper} from "@/modules/popper";
import {initHideButton, showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {initLanguage} from "@/modules/language/language";
import {
    clearGeoJsonLayers, createGeoJsonLayer,
    generateGeoJsonObjectFromFeature,
    setVisibleLayersIncludes, toggleGeoJsonLayer
} from "@/helpers/ol/ol-geo-json-helper";
import {Geometry} from "ol/geom";
import {Feature} from "ol";
import {viewFit} from "@/helpers/ol/ol-view";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {getActiveFilter} from "@/helpers/filter/filter-helper";
import {loadInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";
import {clearWordPrint} from "@/helpers/word/word-helper";
import {getKVLayerByBookmarkPresentationID, getKVLayerByDomainIDAndPresentationID} from "@/helpers/kv/kv-layer-helper";
import {deselectFeature} from "@/modules/ol/service/ol-service-wfs";
import {removeInfoMvt} from "@/modules/ol/service/ol-service-mvt.js";
import {removeCycloramaPlugin} from "@/helpers/ol/ol-plugin-helper.js";
import {getDefaultZoom} from "@/helpers/ol/ol-zoom-helper.js";
import {showImageModal} from "@/components/layout/image-model-component.js";
import {disableMoveLayer} from "@/helpers/ol/map/ol-move-helper.js";
import {getProjectionByBookmarkPresentationID} from "@/helpers/ol/ol-layer-helper.js";
import {GeoJSON} from "ol/format.js";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper.js";
import {Vector} from "ol/layer";
import VectorSource from "ol/source/Vector";
import {initDataTableEditor} from "@/helpers/datatable/datatable-editor-helper.js";
import {initDataTable} from "@/helpers/datatable/datatable-helper.js";

let elementActiveFound

export function loadInfo(result, zoomToResult = false, isFilterClick = false) {

    showElementsBySelector('layer-info-info-button')

    setVisibleLayersIncludes()
    window.geometries = []
    window.breadCrumbs = []
    window.loadAfterClickForms = []
    window.measureFeatures = window.measureFeatures.splice(100000, 1)
    window.measurePrintFeatures = []

    delete window.ShowMultipleRecordsInTable

    if(!result) {
        return ''
    }

    let innerHtml =  `<div class="info-menu-info-header">`

    let totalMainTabs = 0
    if(result.mainTabs) {
        totalMainTabs = result.mainTabs.filter(mainTab => mainTab.features.length > 0).length
    }

    const foundNotEmptyMainTab = false
    if(totalMainTabs > 0) {
      innerHtml +=  `<div class="card mb-3 mr-3 bg-lighter pb-2 mt-3" style="border-radius: 0 10px 10px 10px;">
        <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
             <h2>
                 <span class="fa fa-info title-icon"></span>
                 <layout-language data-key="information"></layout-language>
                 <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnCloseInfoMenu" data-parent-element="layer-info-info">
                    <span class="fa fa-times"></span>
                </button>
                 <button title="Minimaliseren" class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                        <span class="fa fa-minus"></span>
                 </button>
             </h2>
         </div>`

        elementActiveFound = false

        if(totalMainTabs > 1) {

            innerHtml += `
           <div class="cover">
               <layer-info-info-item-header-arrow data-direction="left"></layer-info-info-item-header-arrow>
                    <div class="nav nav-tabs scrollmenu">`
            result.mainTabs.map((mainTab, index) => {
                if (mainTab.features.length > 0) {
                    if (index === 0 && zoomToResult) {
                        const feature = generateGeoJsonObjectFromFeature(mainTab.features[0].feature);
                        let maxZoom = undefined
                        if (feature[0].getGeometry().getType() === 'Point') {
                            maxZoom = window.urlParamsObject.zoom
                            if (!maxZoom) {
                                maxZoom = getDefaultZoom()
                            }
                        }

                        viewFit(feature[0].getGeometry(), undefined, maxZoom, 0, true)
                    }

                    let elementActive = ''
                    if (!elementActiveFound) {
                        elementActive = 'active'
                    }
                    innerHtml += `<layer-info-info-item-header data-bookmark-presentation-name="` + mainTab.BookmarkPresentationID + `" data-class="` + elementActive + `" data-index="` + index + `" data-main-tab-name="` + mainTab.Name + `"></layer-info-info-item-header>`

                    elementActiveFound = true
                }
            })

            innerHtml +=
            `</div>
                <layer-info-info-item-header-arrow data-direction="right"></layer-info-info-item-header-arrow>
            </div>`
        } else {
            result.mainTabs.map((mainTab, index) => {
                if (mainTab.features.length > 0 && index === 0 && zoomToResult) {
                    const vectorSource = new VectorSource()
                    // const features = []
                    mainTab.features.map(feature => {
                        vectorSource.addFeature(generateGeoJsonObjectFromFeature(feature.feature)[0])
                    })

                    setTimeout(() => {
                        viewFit(vectorSource.getExtent(), undefined, window.urlParamsObject.zoom, 0, true)
                    })
                }
            })
        }
    }

    let marginTop = ''
    if(!elementActiveFound) {
        marginTop = 'mt-3'
    } else {

        marginTop = 'ml-3'
    }

    const activeFilter = getActiveFilter()

    if(activeFilter) {

        const mainTab = result.mainTabs.find(mainTab =>
            mainTab.BookmarkPresentationID === activeFilter.BookmarkPresentationID ||
            mainTab.ID === activeFilter.PresentationID ||
            mainTab.ID === activeFilter.PresentationLinkedID
        )

        if(mainTab && !mainTab.BookmarkPresentationID) {
            mainTab.BookmarkPresentationID = activeFilter.BookmarkPresentationID
        }

        if(isFilterClick && mainTab && mainTab.features && mainTab.features.length > 0) {
            innerHtml += '<layer-info-info-item-filter-navigation data-bookmark-presentation-id="' + mainTab.BookmarkPresentationID + '"></layer-info-info-item-filter-navigation>'
        }
    }

    innerHtml +=  `
<!--    <div class="card mb-3 mr-3 bg-lighter pb-2 `+ marginTop + `" style="border-radius: calc(.125rem - 0px) calc(.125rem - 0px) 0 0;min-height:460px;max-height: calc(100vh - 209px);overflow: auto;-webkit-overflow-scrolling: touch;">-->
     `
    innerHtml += loadLayerInfoInfoItems(result.mainTabs, foundNotEmptyMainTab, null, 0)

    if(totalMainTabs === 0) {
        innerHtml = `
        <div class="info-menu-info-header">
            <div class="card mb-3 mr-3 bg-lighter pb-2 mt-3" style="border-radius: 0 10px 10px 10px;max-height: calc(100vh - 209px);overflow: auto;-webkit-overflow-scrolling: touch;">
                <div class="card-header font-weight-bold p-2 info-menu-info-draggable">
                     <h2>
                         <span class="fa fa-info title-icon"></span>
                         <layout-language data-key="information"></layout-language>
                         <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                            <span class="fa fa-times"></span>
                         </button>
                     </h2>
                 </div>
                <div id="divInfoMenuInfoEmpty" class="info-menu-info">
                    <div class="card-body pl-2" style="margin-top:20px">
                        <p>
                            Klik op een object in de kaart voor informatie
                        </p>
                    </div>
                </div>
        `
        deselectFeature()
    }

    innerHtml += `</div>
     </div>`

    document.querySelector('layer-info-info').innerHTML = innerHtml

    const slcLayerInfoInfo = document.getElementById('slcLayerInfoInfo')
    if(slcLayerInfoInfo) {
        slcLayerInfoInfo.addEventListener('change', (event) => {
            const target = slcLayerInfoInfo.options[slcLayerInfoInfo.selectedIndex]

            let elementToShow = {}
            elementToShow.element = null
            elementToShow.depth = 0

            document.querySelectorAll('layer-info-info-item').forEach(element => {
                const dataset = element.dataset
                if (dataset.index === target.dataset.index) {
                    if (dataset.depth >= elementToShow.depth) {
                        elementToShow.element = element
                        elementToShow.depth = dataset.depth
                        toggleGeoJsonLayer(0, dataset.index, true)
                    }

                } else {
                    element.classList.add('d-none')
                    toggleGeoJsonLayer(0, dataset.index, false)
                }
            })

            elementToShow.element.classList.remove('d-none')
        })
    }

    initPopper()
    initHideButton()
    initLanguage()
    checkHeaderArrows()
    showElementsBySelector('kaart-viewer')
}

export function loadLayerInfoInfoItems(mainTabs, foundNotEmptyMainTab, mainTabIndex = null, depth = null) {

    let innerHtml = ''

    window.mainTabs = mainTabs

    if(mainTabs && mainTabs.length > 0) {

        window.dataTables = []

        mainTabs.map((mainTab, index) => {
            const filter = getBySelector('layer-info-filter')
            if (depth === 0 || !filter.classList.contains('d-none')) {
                mainTabIndex = index
                window.breadCrumbs[mainTabIndex] = []
            }

            if (mainTab.features.length > 0) {

                if (depth === null) {
                    depth = window.breadCrumbs[mainTabIndex].length
                }

                window.breadCrumbs[mainTabIndex].push(mainTab)
                let hideElement = ''

                let breadCrumbsIndex = 0
                mainTab.Depth = depth
                if (foundNotEmptyMainTab) {
                    hideElement = 'd-none'
                } else {
                    loadInfoCharacteristics(mainTab.BookmarkPresentationID, false)

                    let presentation = getKVLayerByBookmarkPresentationID(mainTab.BookmarkPresentationID)
                    if(!presentation) {
                        presentation = getKVLayerByDomainIDAndPresentationID(mainTab.DomainID, mainTab.ID)
                    }

                    if(window.windowSettings.width) {
                        getBySelector('.info-menu').style.width = window.windowSettings.width
                    } else {
                        let width = '35rem'
                        if(presentation && presentation.InfoBoxWidth) {
                            width = presentation.InfoBoxWidth
                        } else if(window.settings.PopupBreedte) {
                            width = window.settings.PopupBreedte
                        }

                        getBySelector('.info-menu').style.width = width
                    }

                    if(window.windowSettings.height) {
                        getBySelector('.info-menu').style.height = ''
                    }

                    if(window.windowSettings.transform) {
                        getBySelector('.info-menu').style.transform = window.windowSettings.transform
                    }

                }

                innerHtml += '<layer-info-info-item data-depth="' + depth + '" data-bread-crumb-index="' + mainTabIndex + '" data-index="' + index + '" class="' + hideElement + '"></layer-info-info-item>'

                foundNotEmptyMainTab = true
            }
        })

        setTimeout(() => {
            window.dataTables.map((dataTable) => {
                if(dataTable.featureInfo.ApplicationID === 1) {
                    if(dataTable.featureInfo.keyColumnType === 1) {
                        initDataTableEditor(dataTable)
                    }
                } else {
                    dataTable.table = initDataTable(dataTable)
                }
            })
        }, 0)
    }

    return innerHtml
}

export function clearInfo() {

    document.querySelector('layer-info-info').innerHTML = `
        <div class="info-menu-info-header info-menu-info-draggable">
            <div class="card mb-3 mr-3 bg-lighter pb-2 mt-3" style="border-radius: calc(.125rem - 0px) calc(.125rem - 0px) 0 0;height:100%;overflow: auto;-webkit-overflow-scrolling: touch;">
                <div class="card-header font-weight-bold p-2 ">
                    <h2>
                        <span class="fa fa-info"></span>
                        <layout-language data-key="information"></layout-language>
                        <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                            <span class="fa fa-times"></span>
                        </button>
                    </h2>
                </div>
                <div id="divInfoMenuInfoEmpty" class="info-menu-info">
                    <div class="card-body pl-2" style="margin-top:20px">
                        <p>
                            Klik op een object in de kaart voor informatie
                        </p>
                    </div>
                </div>
            </div>
        </div>
        `
    initPopper()
    initHideButton()
    initLanguage()
    clearGeoJsonLayers()
    clearWordPrint()
    deselectFeature(true)
    removeInfoMvt()
    removeCycloramaPlugin()
    disableMoveLayer(true)
}

export function checkHeaderArrows() {

    const scrollMenu =  document.querySelector(".scrollmenu");
    let left = document.querySelector('[data-direction="left"]');
    let right = document.querySelector('[data-direction="right"]');

    if(!left || !right) {
        return
    }

    if(left) {
        left = left.firstChild
    }
    if(right) {
        right = right.firstChild
    }

    if(scrollMenu.scrollWidth === scrollMenu.clientWidth) {
        left.classList.add('disabled')
        right.classList.add('disabled')
    } else {
        left.classList.remove('disabled')
        right.classList.remove('disabled')

        if (scrollMenu.scrollLeft === 0) {
            left.classList.add('disabled')
        } else {
            left.classList.remove('disabled')
        }

        if (Math.abs(scrollMenu.scrollLeft) === scrollMenu.scrollWidth - scrollMenu.clientWidth) {
            right.classList.add('disabled')
        } else {
            right.classList.remove('disabled')
        }
    }
}
